import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Icon, Popup, Dimmer } from 'semantic-ui-react';
import classNames from 'classnames';
import Emoji from '../../../../Reusable/Emoji';
import { useAppContext } from '../../../../../context/AppContext';

import './an-image.scss';

import PhotoDimmer from './PhotoDimmer';
import InfosDimmer from './InfosDimmer';

const LIKED_PICTURES_STORAGE_KEY = 'likedPictures';

const readLikedPictures = () => {
  if (typeof window === 'undefined') {
    return {};
  }

  const rawValue = window.localStorage.getItem(LIKED_PICTURES_STORAGE_KEY);
  if (!rawValue) {
    return {};
  }

  try {
    const parsed = JSON.parse(rawValue);
    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) {
      return {};
    }
    return parsed;
  } catch {
    return {};
  }
};

const markPictureAsLiked = (pictureId) => {
  if (typeof window === 'undefined') {
    return;
  }

  const likedPictures = readLikedPictures();
  likedPictures[String(pictureId)] = true;
  window.localStorage.setItem(LIKED_PICTURES_STORAGE_KEY, JSON.stringify(likedPictures));
};

const AnImage = ({ photo, allPictures, className, style }) => {
  const { actions } = useAppContext();
  
  const [currentIndex, setCurrentIndex] = useState('')

  const [heartLiked, handleHeartLiked] = useState(() => {
    const likedPictures = readLikedPictures();
    return likedPictures[String(photo.id)] === true;
  });

  const [openPopUp, setOpenPopUp] = useState(false)
  const [openDimmer, setOpenDimmer] = useState(false)

  const [photoOpenDimmer, setphotoOpenDimmer] = useState(false)
  const [infosOpenDimmer, setinfosOpenDimmer] = useState(false)
  
  const handleClick = (value, data) => { 
    setOpenDimmer(!openDimmer);

    switch (value) {
      case "photo" :
        setphotoOpenDimmer(true);
        setinfosOpenDimmer(false);
        setCurrentIndex(Number(data.key))
        break;
      case "infos" :
        setinfosOpenDimmer(true);
        setphotoOpenDimmer(false);
        setCurrentIndex(Number(data.key))
        actions.getGpsData(`${photo.id}`)
        break;
    }
  };

  const likedThis = async () => {
    if (heartLiked) {
      return;
    }

    try {
      await actions.addLike(photo.id);
      handleHeartLiked(true);
      markPictureAsLiked(photo.id);
    } catch (_error) {
      // keep button available if request fails.
    }
  };

  const heartClassname = classNames(
    {
      'heart--liked': heartLiked,
    }
  );

  // permet de selectionner la photo à afficher dans le dimmer (lightbox) en fonction de l'index
  const pictureToShowOnDimmer = allPictures.find(photo => Number(photo.key) === Number(currentIndex));
  
  return (

    <div
      className={classNames('selected-image', className)}
      style={style}
    >
      <img
        src={photo.src}
        alt={photo.alt || photo.title || 'Gallery picture'}
        loading={photo.loading || 'lazy'}
      />
      <div className="overlay">
        <div className="top">          
          <div className="title">{photo.title}</div>
        </div>
        <div className="center">
          <Icon onClick={() => handleClick('photo', photo)} circular name='expand' />
          <Icon onClick={() => handleClick('infos', photo)} circular name='info' />
        </div>
        <div className="bottom">
          <Popup
            open={openPopUp}
            onClose={() => setOpenPopUp(false)}
            onOpen={() => setOpenPopUp(true)}
            on='hover'
            position='top center'
            size='mini'
            pinned
            trigger={<button onClick={likedThis} className="likes" disabled={heartLiked}> <Icon name='heart' className={heartClassname} />{photo.likes}</button>}
          >
            <Popup.Content>
              {!heartLiked ? 
                <div className="custom-popup">Want to Support ? Add your like ! {<Emoji emoji='nerd_face' set='google' size={22} />}</div> 
                :
                <div className="custom-popup">Thanks a lot! You already liked this photo. {<Emoji emoji='heart_eyes' set='google' size={22} />}</div>
              }
            </Popup.Content>
          </Popup>            
        </div>               
      </div>

      <Dimmer className="dimmer-all-page" active={openDimmer} onClickOutside={handleClick} page>
        
        {photoOpenDimmer && <PhotoDimmer allPictures={allPictures} handleClick={handleClick} currentIndex={currentIndex} />}
        
        {infosOpenDimmer && <InfosDimmer photo={pictureToShowOnDimmer} handleClick={handleClick} />}

      </Dimmer>
    </div>
  );

};

AnImage.propTypes = {
  photo: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    key: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    title: PropTypes.string,
    likes: PropTypes.number,
    src: PropTypes.string.isRequired,
    alt: PropTypes.string,
    loading: PropTypes.oneOf(['eager', 'lazy']),
  }).isRequired,
  allPictures: PropTypes.arrayOf(PropTypes.object).isRequired,
  className: PropTypes.string,
  style: PropTypes.shape({
    gridColumn: PropTypes.string,
    gridRow: PropTypes.string,
  }),
};

AnImage.defaultProps = {
  className: '',
  style: undefined,
};

export default AnImage;
